import styled from 'styled-components';

export const ContactInfoSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
`;

export const ContactOverview = styled.section`
  width: 100%;

  padding: var(--space-xl);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);

  background: var(--white);

  box-shadow:
    0 18px 50px rgba(23, 23, 23, 0.05),
    0 2px 8px rgba(23, 23, 23, 0.025);

  @media screen and (max-width: 700px) {
    padding: var(--space-l);
  }
`;

export const OverviewContent = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: flex-start;
  gap: var(--space-l);

  @media screen and (max-width: 520px) {
    grid-template-columns: 1fr;
    gap: var(--space-m);
  }
`;

export const OverviewIcon = styled.div`
  width: 54px;
  height: 54px;

  display: grid;
  place-items: center;

  flex-shrink: 0;

  border: 1px solid rgba(230, 139, 7, 0.16);
  border-radius: var(--borderRadius);

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 1.15rem;

  svg {
    display: block;
  }
`;

export const OverviewLabel = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.72rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.13em;
`;

export const OverviewTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.55rem, 2.5vw, 2.05rem);
  line-height: 1.1;
  font-weight: 800;

  letter-spacing: -0.03em;
`;

export const OverviewDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);

  margin-top: var(--space-l);

  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const OverviewDetail = styled.div`
  min-width: 0;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-m);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadius);

  background: var(--cardBackground);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.92rem;
  line-height: 1.6;
  font-weight: 500;

  address {
    margin: 0;

    color: var(--grey6);

    font-style: normal;
    font-weight: 700;
    line-height: 1.6;

    word-break: break-word;
  }

  span {
    display: flex;
    flex-direction: column;
    gap: var(--space-xxxs);
  }

  strong {
    color: var(--grey7);

    font-size: 0.95rem;
    font-weight: 800;
  }
`;

export const OverviewDetailIcon = styled.span`
  width: 30px;
  height: 30px;
  /* 
  display: grid;
  place-items: center; */
  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 50%;
  padding: 0.15rem;

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 0.72rem;

  svg {
    display: block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const ContactCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-l);

  @media screen and (max-width: 1080px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactCard = styled.article`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  padding: var(--space-l);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadius);

  background: var(--white);

  box-shadow:
    0 12px 32px rgba(23, 23, 23, 0.04),
    0 2px 6px rgba(23, 23, 23, 0.02);

  transition:
    transform 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;

  &:hover {
    border-color: rgba(230, 139, 7, 0.28);

    box-shadow:
      0 18px 42px rgba(23, 23, 23, 0.07),
      0 3px 8px rgba(23, 23, 23, 0.025);

    transform: translateY(-3px);
  }
`;

export const ContactCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-m);
`;

export const ContactAvatar = styled.div`
  width: 46px;
  height: 46px;

  display: grid;
  place-items: center;

  flex-shrink: 0;

  border: 1px solid rgba(230, 139, 7, 0.16);
  border-radius: 50%;

  background: var(--yellow1);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 1rem;
  font-weight: 800;
`;

export const ContactHeaderContent = styled.div`
  min-width: 0;
`;

export const ContactHeader = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: 1.12rem;
  line-height: 1.3;
  font-weight: 800;

  letter-spacing: -0.015em;
`;

export const ContactRole = styled.p`
  margin: var(--space-xxxs) 0 0;

  color: var(--grey4);

  font-size: 0.84rem;
  line-height: 1.45;
  font-weight: 600;
`;

export const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
`;

export const ContactDetail = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: flex-start;
  gap: var(--space-s);

  padding-top: var(--space-s);

  border-top: 1px solid var(--grey15);

  &:first-child {
    padding-top: 0;

    border-top: 0;
  }
`;

export const ContactDetailIcon = styled.span`
  width: 30px;
  height: 30px;

  display: grid;
  place-items: center;

  flex-shrink: 0;

  border-radius: 50%;

  background: var(--grey15);

  color: var(--orange5);

  font-size: 0.7rem;

  svg {
    display: block;
  }
`;

export const ContactDetailContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: var(--space-xxxs);
`;

export const ContactDetailLabel = styled.span`
  color: var(--grey3);

  font-family: var(--mainFont);
  font-size: 0.7rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

export const ContactLink = styled.a`
  width: fit-content;
  max-width: 100%;

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 700;

  text-decoration: none;

  overflow-wrap: anywhere;
  text-transform: lowercase;

  transition:
    color 180ms ease,
    text-decoration-color 180ms ease;

  &:hover {
    color: var(--orange5);

    text-decoration: underline;
    text-underline-offset: 3px;
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 3px;

    border-radius: 3px;
  }
`;
